import React, { useState } from 'react'
import styles from './index.module.scss'
import PrimaryButton from '../button'
import schedule_data from './schedule-data'
import AnchorIcon from '../../assets/anchor.svg'
import ClockIcon from '../../assets/clock-icon.svg'
import swal from 'sweetalert'

const Schedule = () => {
    const [value, setValue] = useState(0)
    const{ programs } = schedule_data[value]
    

    const handleScheduleDownload = () => {
        // swal({
        //     title: "Coming Soon",
        //     text: "Schedule not currently available for download, check back later",
        //     icon: "info",
        // });

        const fileUrl = "../../assets/Easter-conference.xlsx"; 
        const fileName = "conference_schedule.xlsx";
    
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    return (
        <section className={styles.schedule_section} id="schedule">
            <div className={styles.schedule_container}>
                <div className={styles.schedule_header}>
                    <h2>Schedule</h2>
                    <p>Planned schedule for each day</p>
                </div>
                <div className={styles.schedule_content}>
                    <div className={styles.tab_container}>
                        {
                            schedule_data.map((schedule, index) => {
                                return(
                                    <div 
                                    className={`${styles.tab_button} ${index === value && styles.active_tab}`}
                                    onClick={() => setValue(index)} key={schedule?.id}>
                                        <h4>{schedule?.day}</h4> 
                                        <p>{schedule?.date}</p> 
                                    </div> 
                                )
                            })
                        }
                    </div>
                    <div className={styles.program_container}>
                        {
                            programs.map((program) => {
                                return(
                                    <div className={styles.schedule_item} key={program?.id}>
                                        <div className={styles.schedule_content}>
                                            <h3>{program?.heading}</h3>
                                            <p>{program?.subheading}</p>
                                            <div className={styles.schedule_detail}>
                                                {
                                                    program?.vessel &&
                                                    <p><img src={AnchorIcon} alt='anchor icon'/> <span>{program?.vessel}</span></p>
                                                }
                                                {   
                                                    program?.time &&
                                                    <p><img src={ClockIcon} alt='clock icon'/>  <span>{program?.time}</span></p>
                                                }
                                                
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className={styles.schedule_button}>
                        <PrimaryButton className={styles.sch_pry_btn} onClick={handleScheduleDownload}>Download Schedule </PrimaryButton>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Schedule